import type { PersistentStorageService } from '../application/PersistentStorageService';

export class PersistentStorageServiceImpl implements PersistentStorageService {
  getItem = (key: string) => localStorage.getItem(key);
  removeItem = (key: string) => localStorage.removeItem(key);
  setItem = (key: string, value: string) => localStorage.setItem(key, value);
  getAllKeys = () => Object.keys(localStorage);
}
